<template>
  <span v-if="getError(field)" for="id_identifier_number" class="validation-error">{{ getError(field) }}</span>
</template>
<script>
export default {
  props: {
    field: null,
  },
};
</script>
